// src/HubPage.js
import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function HubPage() {
  const cardStyle = {
    height: "250px", // Fixed height for all cards
    display: "flex",
    flexDirection: "column", // Ensures the content inside the card is in a column layout
    justifyContent: "center",
  };

  return (

    <div className="container mt-5">
      <Helmet>
        <title>6Degree - Your Hub for Blockchain-based Decisions and Rewards</title>
        <meta name="description" content="Welcome to the 6Degree Hub, where blockchain meets decision-making. Explore and engage with our smart contract-driven platform." />
      </Helmet>
      <h1 className="text-center">News Prediction App - Administration Hub</h1>
      <div className="row mt-5">
        <div className="col-md-4 mb-3">
          <div className="card" style={cardStyle}>
            <div className="card-body text-center">
              <h5 className="card-title">Assign/Revoke Roles</h5>
              <p className="card-text">Manage admin and creator roles.</p>
              <Link to="/assign-roles" className="btn btn-primary">
                Go to Assign Roles
              </Link>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <div className="card" style={cardStyle}>
            <div className="card-body text-center">
              <h5 className="card-title">Create a  Topic</h5>
              <p className="card-text">Create new  topics for betting.</p>
              <Link to="/create-topic" className="btn btn-primary">
                Go to Create  Topic
              </Link>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <div className="card" style={cardStyle}>
            <div className="card-body text-center">
              <h5 className="card-title">View Existing  Topics</h5>
              <p className="card-text">View and interact with existing topics.</p>
              <Link to="/existing-topics" className="btn btn-primary">
                Go to Existing  Topics
              </Link>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <div className="card" style={cardStyle}>
            <div className="card-body text-center">
              <h5 className="card-title">Claim Rewards</h5> {/* New card for Claim Rewards */}
              <p className="card-text">Claim your rewards or refunds from past bets.</p>
              <Link to="/claim-rewards" className="btn btn-primary">
                Go to Claim Rewards
              </Link>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <div className="card" style={cardStyle}>
            <div className="card-body text-center">
              <h5 className="card-title">Statistics</h5>
              <p className="card-text">View statistics on bets and topics.</p>
              <Link to="/statistics" className="btn btn-primary">
                Go to Statistics
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HubPage;
